import { AfterViewInit, Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SpinnerService } from './spinner.service';

@Component({
  selector: 'app-innerspinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerInnerComponent implements OnInit, AfterViewInit {

  constructor(
    public spinner: SpinnerService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void{
    this.cdr.detectChanges();

  }

}